import { Outlet, useParams } from "react-router-dom";
import { ChatProvider } from "./context/use-chat";
import { trpc } from "./trpc";
import { PublicGetAssistant } from "@sdr/schemas/assistants";
import { Theme } from "./theme";

export const Component = () => {
  const params = useParams<PublicGetAssistant>();
  const [assistant] = trpc.assistants.public.get.useSuspenseQuery({
    id: params.id!,
  });
  return (
    assistant && (
      <Theme assistant={assistant}>
        <ChatProvider assistant={assistant}>
          <Outlet />
        </ChatProvider>
      </Theme>
    )
  );
};
